module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/wager-3057dfbd1ea7d6c1.png"+" 120w",
        images: [{path: __webpack_public_path__ + "assets/images/wager-3057dfbd1ea7d6c1.png",width: 120,height: 120}],
        src: __webpack_public_path__ + "assets/images/wager-3057dfbd1ea7d6c1.png",
        toString: function(){return __webpack_public_path__ + "assets/images/wager-3057dfbd1ea7d6c1.png"},
        
        width: 120,
        height: 120
      }